import PropTypes from 'prop-types';
import React from 'react';
import { useLocale } from 'next-intl';

const Date = props => {
  const locale = useLocale();
  const { month, day, year } = props;

  const monthString = {
    de: {
      '01': 'Januar',
      '02': 'Februar',
      '03': 'März',
      '04': 'April',
      '05': 'Mai',
      '06': 'Juni',
      '07': 'Juli',
      '08': 'August',
      '09': 'September',
      10: 'Oktober',
      11: 'November',
      12: 'Dezember'
    },
    en: {
      '01': 'January',
      '02': 'February',
      '03': 'March',
      '04': 'April',
      '05': 'May',
      '06': 'June',
      '07': 'July',
      '08': 'August',
      '09': 'September',
      10: 'October',
      11: 'November',
      12: 'December'
    }
  };

  const renderDate = () => {
    if (locale === 'en') {
      return `${monthString[locale][month]} ${day}, ${year}`;
    }

    return `${day}. ${monthString[locale][month]} ${year}`;
  };
  return <time {...props}>{renderDate()}</time>;
};

Date.propTypes = {
  day: PropTypes.string.isRequired,
  month: PropTypes.string.isRequired,
  year: PropTypes.string.isRequired
};

export default Date;
